import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { SVGFC } from '@repo/toolkit/types'

const PendingIcon: SVGFC = ({ color = tailwindColors.blue.DEFAULT, ...props }) => {
  return (
    <svg
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.2882 7.67517C15.4883 7.8752 15.6007 8.14651 15.6007 8.42941V9.69293C15.97 9.74848 16.3269 9.84192 16.6673 9.96912V8.42941C16.6673 7.86363 16.4425 7.32099 16.0425 6.92091L13.2464 4.12484C12.8463 3.72476 12.3037 3.5 11.7379 3.5H5.46732C4.28911 3.5 3.33398 4.45513 3.33398 5.63333V17.3667C3.33398 18.5449 4.28911 19.5 5.46732 19.5H11.9898C11.5226 19.2097 11.1036 18.8493 10.7475 18.4333H5.46732C4.87821 18.4333 4.40065 17.9558 4.40065 17.3667V5.63333C4.40065 5.04423 4.87821 4.56667 5.46732 4.56667H11.7379C12.0208 4.56667 12.2921 4.67905 12.4921 4.87909L15.2882 7.67517Z"
        fill={color}
      />
      <path
        d="M15.8849 13.0635C15.9641 12.7798 15.7983 12.4857 15.5146 12.4065C15.2309 12.3273 14.9367 12.4931 14.8575 12.7768L14.5278 13.9582L14.2434 13.6811C14.0324 13.4755 13.6948 13.4799 13.4892 13.6909C13.2837 13.9018 13.2881 14.2395 13.499 14.445L14.4276 15.3498C14.5625 15.4812 14.7567 15.5318 14.9385 15.4828C15.1203 15.4338 15.2629 15.2926 15.3135 15.1112L15.8849 13.0635Z"
        fill={color}
      />
      <path
        d="M11.0972 13.9003C10.7384 13.9003 10.4735 13.5628 10.611 13.2314C11.2922 11.5888 12.9113 10.4336 14.8002 10.4336C17.3039 10.4336 19.3336 12.4632 19.3336 14.9669C19.3336 17.4706 17.3039 19.5003 14.8002 19.5003C12.6879 19.5003 10.9129 18.0555 10.4097 16.1002C10.3287 15.7854 10.5835 15.5003 10.9085 15.5003C11.1765 15.5003 11.4 15.6975 11.4763 15.9544C11.9015 17.3879 13.2287 18.4336 14.8002 18.4336C16.7148 18.4336 18.2669 16.8815 18.2669 14.9669C18.2669 13.0523 16.7148 11.5003 14.8002 11.5003C13.4004 11.5003 12.1944 12.3299 11.6471 13.5243C11.5468 13.743 11.3377 13.9003 11.0972 13.9003Z"
        fill={color}
      />
    </svg>
  )
}

export default PendingIcon
